import type { ActivityReportComponentProps } from './ActivityReportComponent';

export const ActivityReportComponent = {
    MountAsync: async (target: HTMLElement, props: ActivityReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ActivityReportComponent } = await import('./ActivityReportComponent');
        return await mountReactComponentAsync(target, ActivityReportComponent, props);
    }
};
